<script>
  import Player from "../player.svelte";
  let episode = 1;
  function nextEpisode() {
    if (episode < 4) {
      episode += 1;
    }
  }
  function previousEpisode() {
    if (episode > 1) {
      episode -= 1;
    }
  }
</script>

{#if episode == 1}
  <Player id="BGOTv1dEZB4" />
  <h2>Expression - 1 Earth</h2>
  <span>
    {#if episode > 1}
      <button on:click={previousEpisode}>&lt; Episode {episode - 1}</button>
    {/if}
    {#if episode < 4}
      <button on:click={nextEpisode}>Episode {episode + 1} &gt;</button>
    {/if}
  </span>
  <p>
    Creator and producer: Katie Eckford (@doublehemisphere)<br />
    Earth Written and Voiced by Becky Downing<br />
    Earth Mother.<br />
    A womb full of gravel and moss<br />
    She calls to the wind with a groan<br />
    Faulted. Weary and trodden<br />
    Muddy<br />
    Sticky<br />
    Sore<br />
    Pattered upon by the feet of a million persons<br />
    A landscape of bruises: purple, yellow, green, brown, black<br />
    Blue<br />
    She screeches at slate in the coal mines<br />
    Barks at the creaking trees<br />
    Her roots are undyed and the curls of her hair make for leaves that seat birds
    nests in the winter<br />
    Warms eggs for the hatching<br />
    Casts shadows over north facing houses in suburban streets<br />
    And Hosts worms in their blackened apartments of soil, rent-free due to low flying
    birds<br />
    She Boasts a belly full of molten<br />
    Hungry, she feasts on the sodden Sand and spits out crabs, shovels, buckets,
    bottles, sweet wrappers, silly string stuck in her teeth.<br />
    Her spine is the mountain, hunched, curved in her age, brittle. She carries the
    weight of time on her back- an endless ticking on her vertebrae.<br />
    She grows weary. Yearns for Eden- her nostalgia weighs her down in the wake of
    another landfill.<br />
    Her children are greedy.<br />
    They eat and eat and eat at the world that she made for them, and leave tooth
    marks and tire tracks and boot prints and potholes on her body.<br />
    They have forgotten it was once their home.<br />
    But still she moves mountains for them.<br />
    Nestles them in the nook of each tree trunk<br />
    Blankets them with warm sand in the desert<br />
    Quenches their thirst with a rambling stream<br />
    Warms their feet in soil and gives them life through her leafy hands, before
    coming to rest in the quiet of the evening for a split second before the crying
    on the other side of the equator begins.<br />
    For Mother’s Day they plucked a daffodil from her eyebrow and left it misshapen,
    forgetting in their haste, to lay seeds.<br />
    She grows tired.<br />
    Melts, crumbles.<br />
    Her hot flushes grow too warm, her legs give out- her face grows lined.<br
    />
    She seeks comfort.<br />
    Bled dry, wrung out, worn thin, she waves goodbye to her children and covers
    herself with the ocean.<br />
    She closes her eyes.
  </p>
{/if}
{#if episode == 2}
  <Player id="_vsCETjjbTM" />
  <h2>Expression - 2 Water</h2>
  <span>
    {#if episode > 1}
      <button on:click={previousEpisode}>&lt; Episode {episode - 1}</button>
    {/if}
    {#if episode < 4}
      <button on:click={nextEpisode}>Episode {episode + 1} &gt;</button>
    {/if}
  </span>
  <p>
    Creator and producer: Katie Eckford (@doublehemisphere)<br />
    Water Written and Voiced by Claire Beerjeraz
  </p>
  <p>
    A conversation with Water:<br />
    The upset of my tears<br />
    Rain down from the clouds It falls back into my body<br />
    And begins to drown It is hard not to be overwhelmed<br />
    When I feel so overflowing<br />
    But I know the sun will dry my tears<br />
    And the clouds will hide my emotion I work so closely with the moon It is like
    she is my sister<br />
    For when she is gone<br />
    My tides are so sinister<br />
    The one space<br />
    Where I have no control<br />
    Except for when the human mind<br />
    Takes me on a renewable road.<br />
    Misunderstood and taken for granted<br />
    I’m just part of the background I wish people were more mindful<br />
    Of the way I can drift around I get blamed but I need safety,<br />
    For I can be hard to tame<br />
    But in the earth, fire and air I have an equal place<br />
    My world encompasses me<br />
    You don’t know how I’m feeling<br />
    For your awareness is to my surface<br />
    Underwater things are deepening<br />
    Lost cities and new species I have a whole other space<br />
    But with depth comes more pressure<br />
    And you can’t withstand my taste I am unique to earth<br />
    My foundations are intricate<br />
    The lattice of my mind<br />
    Both complicated and hard to define<br />
    But that coolness I exert<br />
    You often enjoy you know how to test my waters I am your body and leave you undefined.<br
    />
    With strength,<br />
    See me become mountainous.<br />
    I avalanche into peoples hearts<br />
    They love my surface and my colour<br />
    Despite the demise when I break apart<br />
    But I am not to be tested<br />
    When it is me vs. You<br />
    For I cannot guarantee<br />
    You will always pull through<br />
    You must train to handle my worse<br />
    For panic or strain, can end up being my winning game<br />
    I can be bleak, frosty and cause you hurt<br />
    But there is warmth deep inside me that we all yearn<br />
    Because soothing heat can be so trusting<br />
    Just don’t stay too long<br />
    Or I’ll start burning.<br />
    And without me, things wouldn’t be the same I feel like part of Mother Nature,<br
    />
    I am one with this dame I can hydrate your mind<br />
    And relax your body I am a medium to lots<br />
    And a necessity to many<br />
    Despite all my flaws,<br />
    It is never my intent<br />
    See I just am who I am<br />
    And it is hard to re-direct<br />
    Myself into something that is always safe in nature<br />
    Take me out of that space<br />
    And I can be much more tamer<br />
    Now don’t choke on my words<br />
    Take a long big sip<br />
    For I am your friend<br />
    This is a life long relationship H20, water or aqua whatever you call me,<br
    />
    Take me in because,<br />
    I am part of your body.
  </p>
{/if}
{#if episode == 3}
  <Player id="pCh-dB2uIPM" />
  <h2>Expression - 3 Air</h2>
  <span>
    {#if episode > 1}
      <button on:click={previousEpisode}>&lt; Episode {episode - 1}</button>
    {/if}
    {#if episode < 4}
      <button on:click={nextEpisode}>Episode {episode + 1} &gt;</button>
    {/if}
  </span>
  <p>
    Creator and producer: Katie Eckford (@doublehemisphere)<br />
    Air Written and Voiced by Claire Beerjeraz
  </p>
  <p>
    My companion air:<br />
    Sometimes I find myself lost,<br />
    I am stationary and I feel complacent.<br />
    I am existing in this world<br />
    My body is resistant<br />
    But then she picks me up<br />
    She reminds me that I am here<br />
    A gentle warmth across my cheek I speak with the atmosphere<br />
    And her energy swirls the leaves<br />
    That have settled on the ground I find peace in her gestures I find clarity all
    around<br />
    When she is cool<br />
    It brings shivers down my spine<br />
    It reminds me I am human<br />
    On the environment I rely<br />
    Her ever-flowing presence<br />
    In the breathes that I take<br />
    She holds what I need<br />
    And takes on what I exhale<br />
    She turns and swirls<br />
    Her body in propelling waves<br />
    Generating a movement<br />
    That can cause me to sway<br />
    She makes me lose balance<br />
    But there’s message behind it<br />
    She’s reminding to pay attention<br />
    To keep moving and stay alive<br />
    In her high latitudes<br />
    I feel choked and faint<br />
    The thinness in her presence<br />
    Makes it easier to find her way<br />
    Into visibility<br />
    So she can be seen<br />
    Airing through the mountains<br />
    Moving gently with a breeze<br />
    She holds a space for the spirits<br />
    For the ghosts and other dimensions<br />
    Air is the atmosphere that holds our visions<br />
    She is a canvas for our eyes<br />
    She holds light not just oxygen<br />
    With her demise<br />
    We could not be coherent<br />
    Breathe in deeply,<br />
    Acknowledge the sensation<br />
    For she is always with you<br />
    Every step of the way<br />
    Filling your lungs<br />
    with love and life<br />
    air,<br />
    the master in the sky,
  </p>
{/if}
{#if episode == 4}
  <Player id="nfCSdXeA8r8" />
  <h2>Expression - 4 Fire</h2>
  <span>
    {#if episode > 1}
      <button on:click={previousEpisode}>&lt; Episode {episode - 1}</button>
    {/if}
    {#if episode < 4}
      <button on:click={nextEpisode}>Episode {episode + 1} &gt;</button>
    {/if}
  </span>
  <p>
    Creator and producer: Katie Eckford (@doublehemisphere)<br />
    Written and Voiced by Becky Downing
  </p>
  <p>Fire</p>
  <p>
    In the Olden days, the days before man, fire was revered<br />
    An unbridled, flaming goddess found only in the eruption of a volcano<br />
    The wake of an asteroid<br />
    The fall of a shooting star<br />
    The belly of a beast<br />
    The eyes of an enemy<br />
    She danced freely, licked the toes of the cold ones, flourished with the earth,
    limbs stretched, mane wild, coloured in with shades of freedom- an entire spectrum
    of light in the minutiae of each hair flick<br />
    Massive, voluptuous and unforgiving<br />
    Until she met man<br />
    Now man will say that he discovered fire<br />
    That he found her at her earliest spark<br />
    But fire came to man<br />
    Watched him from afar<br />
    Pitied him in the wake of an ice age<br />
    Melted for his features, lonely and cold<br />
    Witnessed his frostbite, his hunger<br />
    Fire softened<br />
    Fire felt<br />
    Fire tiptoed into the palm of man’s hands to tickle his fingers<br />
    And man was amazed<br />
    Man was besotted with fire<br />
    Man would sit patiently, at first, waiting for nightfall to call her<br />
    For fire to wake up from her slumber<br />
    To hold him in her embers<br />
    To flicker at the stars - her sisters- with him at her side, watchful.<br />
    Adoring.<br />
    Fire would dance for man, freely.<br />
    Welcome him to her bedside, his gaze, his awe at her heat, her movement, her
    colour<br />
    Her power<br />
    But man was not the only admirer Inviting his friends to meet fire, man saw green
    instead of red<br />
    Man became jealous, petty<br />
    Man laid his claim<br />
    But fire was not mans<br />
    She did not belong to him,<br />
    And when man tried to catch her<br />
    Fire burned<br />
    Fire had grown too large for man, shown too much of her ethereal self in the
    heat of a moment<br />
    Fire wanted to leave but man was clever<br />
    Lulled fire into piles of cosy wood<br />
    Learnt to piston her with water<br />
    Left her in the middle of the night, lit and waiting, only to walk away and leave
    her to die out in a pile of soot and charred leaves<br />
    Man became vengeful<br />
    Used fire to feed himself<br />
    Caught fire in a way that wouldn’t burn his hands Kept her in small doses of
    her self<br />
    Limited her breadth Kept her in capsules and lanterns and matchboxes and street
    lamps and lightbulbs and pocket lighters<br />
    Man indulged on fires power<br />
    Sold her off to strangers for capital<br />
    Kept her amongst his brothers, cut off strands of her hair to keep in their pockets
    and drawers and placed her on the lips of greedy smokers to pull out toxins and
    wrap their mouths around her heat on a cold<br />
    November night before leaving her abandoned at the end of cigarette butt on the
    cold cobbles of a deserted club alleyway<br />
    Man broke fires heart<br />
    Capitalised on her power<br />
    Used her to pillage and claim<br />
    Stole away her freedom<br />
    Burnt her too furiously<br />
    Too greedily Used her for personal gain<br />
    Gorged her with oil and coal<br />
    Scorched her sisters in<br />
    Salem, ripped off fires hair and fed it to the straw that they stood upon<br
    />
    Marred their flesh with fires hands Left her, broken and smoking at the stake<br
    />
    With their charred bodies<br />
    And fire burned<br />
    Burned in her chest<br />
    Kindled an anger for years in her belly that burst out in an agony<br />
    Saw red in the pockets of men<br />
    Clotted their lungs with smoke and freed herself<br />
    Set alight oil slicks<br />
    Lit the torches of rioters<br />
    Fled with fury through the rainforests<br />
    Boiled over the saucepans and scalded men’s hands with hot water and steam<br
    />
    Fled to the beaches and turned man’s skin to blisters<br />
    Set alight houses as man slept<br />
    Before facing him once more In the coals of his fireplace<br />
    One December night<br />
    Where he sat<br />
    Shivering<br />
    Blue<br />
    Teeth chattering, all alone In the icy clutch of her sisters- water and air<br
    />
    Scouring snowflakes off his skin with his fingertips<br />
    As he reached out for her warmth<br />
    As she flickered for the final time<br />
    And extinguished herself<br />
    In a puff of cruel smoke<br />
    leaving him cold.
  </p>
{/if}

<style>
  button {
    padding: 8px;
    margin: 0 8px;
    border-radius: 0;
    background-color: transparent;
    color: #fff;
    border: 2px solid #b2dee5;
  }
  button:hover {
    background-color: rgba(0, 0, 0, 0.3);
  }
</style>
